export var STORAGE;
(function (STORAGE) {
    STORAGE["USER_CONTEXT"] = "user_context";
    STORAGE["WELCOME_DIALOG_SHOWN"] = "ai-discoverability-welcome-dialog-shown";
})(STORAGE || (STORAGE = {}));
